import { put, select, takeEvery } from 'typed-redux-saga/macro';
import { getFeed } from 'actions';
import { CANCEL_SUBSCRIPTIONS_SUCCESS, CHANGE_DATE_TRANSACTION_SUCCESS, CHOOSE_RETAINED_CONNECTIONS_SUCCESS, CLOSED_CONNECTION_SUCCESS, CLOSE_ACCOUNT_SUCCESS, CREATE_ACCOUNT_SUCCESS, CREATE_TRANSACTION_SUCCESS, CREATE_TRANSACTION_SCHEDULE_SUCCESS, DELETE_ACCOUNT_SUCCESS, DELETE_CATEGORY_SUCCESS, DELETE_CONNECTION_SUCCESS, DELETE_INCOME_SUCCESS, DELETE_TRANSACTION_SUCCESS, DISMISS_QUIZ_SUCCESS, EDIT_ACCOUNT_SUCCESS, EDIT_CATEGORY_SUCCESS, EDIT_SUBSCRIPTIONS_SUCCESS, HIDE_SUCCESS, ON_SUBMIT_FEEDBACK_SUCCESS, PROCESS_TRANSACTIONS_SUCCESS, REFRESH_ON_START, SAVE_TOTAL_BUDGET_SUCCESS, SET_ACCOUNT_TYPE_SUCCESS, SET_CONNECTIONS_STATUS, SET_INCOME_SUCCESS, SET_PRIMARY_INCOME_SUCCESS, SPLIT_TRANSACTION_SUCCESS, UNSPLIT_TRANSACTION_SUCCESS, UPDATE_CATEGORY_SUCCESS, UPDATE_CATEGORIES_PREFERENCES_SUCCESS, DELETE_MERCHANT_SUGGESTION_SUCCESS, } from 'actions/types';
import { ADD_TXN_TO_SUBSCRIPTION_BY_ID_SUCCESS, ADD_TXNS_TO_SUBSCRIPTION_SUCCESS, DELETE_TXN_FROM_SUBSCRIPTION_SUCCESS, } from 'features/subscriptions/actions/types';
import { selectExcludedCategoryIds } from 'reducers/selectors';
import { checkIfNeedToRefreshMonthlyTotals } from 'utils/api/refresh';
import { selectIsFeedRefreshing } from '../selectors';
function* refreshFeedSaga(action) {
    if (action.payload === true) {
        return;
    }
    const isRefreshing = yield* select(selectIsFeedRefreshing);
    if (isRefreshing) {
        return;
    }
    const excludedCategoryIds = yield* select(selectExcludedCategoryIds);
    if (checkIfNeedToRefreshMonthlyTotals(action, excludedCategoryIds)) {
        yield* put(getFeed());
    }
}
function* feedSaga() {
    yield* takeEvery((action) => [
        ADD_TXN_TO_SUBSCRIPTION_BY_ID_SUCCESS,
        ADD_TXNS_TO_SUBSCRIPTION_SUCCESS,
        DELETE_TXN_FROM_SUBSCRIPTION_SUCCESS,
        CANCEL_SUBSCRIPTIONS_SUCCESS,
        CHANGE_DATE_TRANSACTION_SUCCESS,
        CLOSED_CONNECTION_SUCCESS,
        CLOSE_ACCOUNT_SUCCESS,
        CREATE_TRANSACTION_SUCCESS,
        CREATE_TRANSACTION_SCHEDULE_SUCCESS,
        PROCESS_TRANSACTIONS_SUCCESS,
        DELETE_ACCOUNT_SUCCESS,
        DELETE_CATEGORY_SUCCESS,
        DELETE_CONNECTION_SUCCESS,
        DELETE_INCOME_SUCCESS,
        DELETE_TRANSACTION_SUCCESS,
        DISMISS_QUIZ_SUCCESS,
        EDIT_SUBSCRIPTIONS_SUCCESS,
        EDIT_CATEGORY_SUCCESS,
        HIDE_SUCCESS,
        ON_SUBMIT_FEEDBACK_SUCCESS,
        DELETE_MERCHANT_SUGGESTION_SUCCESS,
        REFRESH_ON_START,
        EDIT_ACCOUNT_SUCCESS,
        CREATE_ACCOUNT_SUCCESS,
        SAVE_TOTAL_BUDGET_SUCCESS,
        SET_ACCOUNT_TYPE_SUCCESS,
        SET_CONNECTIONS_STATUS,
        SET_INCOME_SUCCESS,
        SET_PRIMARY_INCOME_SUCCESS,
        SPLIT_TRANSACTION_SUCCESS,
        UNSPLIT_TRANSACTION_SUCCESS,
        UPDATE_CATEGORY_SUCCESS,
        UPDATE_CATEGORIES_PREFERENCES_SUCCESS,
        CHOOSE_RETAINED_CONNECTIONS_SUCCESS,
    ].includes(action.type), refreshFeedSaga);
}
export default feedSaga;
